import React from "react"
import "./style.scss"

const DetailButtonContainer = ({ children, className = "button-item" }) => {
  return (
    <div className="shared-insights-detail-button-container">
      {React.Children.map(children, (child, i) => {
        if (!child) {
          return null
        }

        return (
          <div className={className} key={i}>
            {child}
          </div>
        )
      })}
    </div>
  )
}

export default DetailButtonContainer
